import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ICellConfig, BaseCellComponent, setupCell } from '../cells/base-cell/base-cell.component';

@Component({
  selector: 'dcl-wrapper',
  template: `<ng-container #target></ng-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DclWrapperComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('target', { read: ViewContainerRef })
  private target: ViewContainerRef;
  private isViewInitialized: boolean;

  @Input() public type: any;
  @Input() public config: ICellConfig;

  public cmpRef: ComponentRef<BaseCellComponent>;

  public constructor(
    private changeDetector: ChangeDetectorRef,
    private renderer: Renderer2,
  ) {
    this.isViewInitialized = false;
  }

  private updateComponent(): void {
    if (this.isViewInitialized === false) {
      return;
    }

    if (this.cmpRef) {
      this.cmpRef.destroy();
    }

    this.cmpRef = this.target.createComponent(this.type);

    if (this.config) {
      this.cmpRef.instance.config = this.config;
    }

    this.changeDetector.detectChanges();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['type'] || !this.cmpRef) {
      this.updateComponent();
    } else if (changes['config'] && this.cmpRef) {
      const prevConfig = changes['config'].previousValue as ICellConfig;
      const el: HTMLElement = this.cmpRef.instance.element?.nativeElement;

      // Remove stale listeners before re-applying so closures capturing
      // render-cycle state (e.g. selectedScans) don't go stale.
      if (el && prevConfig?.listeners) {
        for (const [event, handler] of Object.entries(prevConfig.listeners)) {
          el.removeEventListener(event, handler);
        }
      }

      this.cmpRef.instance.config = this.config;

      if (el && this.config) {
        setupCell(this.renderer, this.config, el);
      }

      this.changeDetector.detectChanges();
    }
  }

  public ngAfterViewInit(): void {
    this.isViewInitialized = true;
    this.updateComponent();
  }

  public ngOnDestroy(): void {
    if (this.cmpRef) {
      this.cmpRef.destroy();
    }
  }

  public markForCheck(): void {
    this.changeDetector.markForCheck();
  }
}
